var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 136,
    viewBox: "0 0 127 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.308855 67.6657C0.583466 27.8698 26.6829 0.147756 63.8007 0.456409C100.919 0.765063 126.63 28.9161 126.353 68.7097C126.078 108.503 99.979 136.228 62.8611 135.919C25.7433 135.61 0.0319749 107.459 0.308855 67.6657Z",
    fill: "#FEBF88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOLetter);
export default __webpack_public_path__ + "static/media/o-letter.08ae314275edd8cc24d19a6520b4fd3b.svg";
export { ForwardRef as ReactComponent };